export const API_URL = 'https://oo0.ru';

export const LOGIN_ENDPOINT = '/api/users/user/login/';

export const LOGOUT_ENDPOINT = '/api/users/user/logout/';

export const CHANGE_EMAIL_ENDPOINT = '/api/users/user/email/';

export const CHANGE_PASSWORD_ENDPOINT = '/api/users/user/password/';

export const USER_INFO_ENDPOINT = '/api/users/user/';

export const ASK_QUESTIONS_ENDPOINT = '/api/feedback/system_question/';

export const GET_ALL_COURSES_ENDPOINT = '/api/courses/';

export const GET_COURSE_ID_ENDPOINT = '/api/courses/course/';

export const UPLOAD_RESOURCE_ENDPOINT = '/api/courses/course/topic/';

export const CREATE_TOPIC_ENDPOINT = '/api/courses/course/';

export const ADD_LINK_ENDPOINT = '/api/courses/course/topic/';

export const GET_ALL_COMMENTS_ENDPOINT = '/api/feedback/resource/';

export const ADD_COMMENT_ENDPOINT = '/api/feedback/resource/';

export const ADD_ANSWER_ENDPOINT = '/api/feedback/resource/comment/';

export const GET_TOPIC_ENDPOINT = '/api/courses/course/topic/';

export const DELETE_RESOURCE_ENDPOINT = '/api/courses/course/topic/resource/';

export const DELETE_TOPIC_ENDPOINT = '/api/courses/course/topic/';
